<div class="container-fluid">
  <app-header titleText="{{pageTitle}}"></app-header>
  <div class="ml-md-5">
    <div class="row mb-3">
      <div class="pr-2">
        <img alt="Exports" src="assets/img/circle_images/export-circle.png" width="50" />
      </div>
      <div>
        <a routerLink="/export/invoices" class="report-link" i18n>Invoices Export</a>
        <p i18n>Exports selected jobs to a csv file to which can be used to import into other sources.</p>
      </div>
    </div>
   
  </div>
</div>

